export function NotImplementedException(entity: string) {
  throw new Error(`${entity} not implemented)`);
}
